// extracted by mini-css-extract-plugin
module.exports = {"button":"Button-module--button--2eUPS","secondary":"Button-module--secondary--2FhyQ","xl":"Button-module--xl--3pZcd"};